#import "../fragments/contact-attachments-fragment.graphql"

mutation RemoveAttachmentFromContact($input: ContactFileRemoveInput!) {
    contactFileRemove(input: $input) {
        contact {
            ...ContactAttachmentsFragment
        }
    }
}
